import script from "./OrderHistoryTrecaDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryTrecaDetail.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryTrecaDetail.vue?vue&type=style&index=0&id=465a2357&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465a2357"]])

export default __exports__